/* eslint-disable react/require-default-props */
import { styled } from '@/configs/stitches.config';

const ListRoot = styled('ul', {
  font: '$bodyRegular',
  listStyleType: 'disc',
  marginBottom: '$spacingLg',
  paddingLeft: '$spacingLg',
});

type RootProps = {
  children: React.ReactNode;
  listStyleType?: 'none' | 'revert' | 'unset' | 'disc';
};

export function Root(props: RootProps): React.ReactElement {
  const { children, listStyleType = 'disc', ...rest } = props;

  return (
    <ListRoot css={{ listStyleType }} {...rest}>
      {children}
    </ListRoot>
  );
}

const ListItem = styled('li', {
  color: '$textColorPrimary',
  font: 'inherit',
  paddingTop: '$spacingSm',
  columnGap: '$spacingSm',

  '&:first-of-type': {
    paddingTop: 0,
  },
});

type ItemProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
};

export function Item(props: ItemProps): React.ReactElement {
  const { children, icon } = props;
  return (
    <ListItem css={{ display: icon ? 'flex' : 'list-item' }}>
      {icon}
      {children}
    </ListItem>
  );
}

export default { Root: styled(Root), Item: styled(Item) };
